import { render, staticRenderFns } from "./DppMenu.vue?vue&type=template&id=138156f4&scoped=true&"
import script from "./DppMenu.vue?vue&type=script&lang=js&"
export * from "./DppMenu.vue?vue&type=script&lang=js&"
import style0 from "./DppMenu.vue?vue&type=style&index=0&id=138156f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138156f4",
  null
  
)

export default component.exports